import './ChallengeCard.css';
import JoinChallengeModal from "../components/JoinChallengeModal";
import { useState } from "react";

function ChallengeCard({ title, description, startDay, allData }) {

  const [modalShow, setModalShow] = useState(false);
    const thumbnail = process.env.PUBLIC_URL + "/trophies.jpg";
    
  return (
    <div className="challenge-card">
      <img src={thumbnail} alt="Video Thumbnail" className="thumbnail" />
      <div className="content">
        <h3 className="title">{title}</h3>
        <p className="description">{description}</p>
        
        <div className="start-day-section">
          <span className="start-day-label">Start Day:</span>
          <span className="start-day">{startDay}</span>
        </div>
        <button className="join-button" onClick={() => setModalShow(true)}>Join</button>
      </div>
      <JoinChallengeModal alldata={allData} show={modalShow} onHide={() => setModalShow(false)} />
    </div>
  );
}

export default ChallengeCard;
